export const commentsTaskAdapter = (data) => {
    const comments = data?.comments;

    return {
        comments: comments,
    };
};
